package one.healthium.insights.ui.insights.models

import one.healthium.loco.LString
import androidx.compose.runtime.Immutable

@Immutable
internal data class HeaderUiModel(
    val id: String,
    val title: LString,
)
